import React from 'react';
import { motion } from 'framer-motion';

// Peepal leaf SVG (from Logo, simplified for watermark)
const PeepalLeaf = ({ className = '', size = 80, style = {}, opacity = 0.08 }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    className={className}
    style={{ opacity, ...style }}
  >
    <path d="M20 5C24 2 30 4 32 10C34 16 30 22 26 26C23 29 21 32 20 35C19 32 17 29 14 26C10 22 6 16 8 10C10 4 16 2 20 5Z" fill="#F9B877" />
    <path d="M20 5C24 2 30 4 32 10C34 16 30 22 26 26C23 29 21 32 20 35C19 32 17 29 14 26C10 22 6 16 8 10C10 4 16 2 20 5Z" fill="url(#leafGradient)" />
    <path d="M20 5C24 2 30 4 32 10C34 16 30 22 26 26C23 29 21 32 20 35C19 32 17 29 14 26C10 22 6 16 8 10C10 4 16 2 20 5Z" stroke="#A67C52" strokeWidth="1.5" fill="none" />
    <defs>
      <linearGradient id="leafGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F27516" stopOpacity="0.2" />
        <stop offset="50%" stopColor="#A67C52" stopOpacity="0.08" />
        <stop offset="100%" stopColor="#DB6459" stopOpacity="0.12" />
      </linearGradient>
    </defs>
  </svg>
);

const FloatingShapes = () => {
  // Peepal leaves at various positions, low opacity
  const leaves = [
    { size: 120, x: '8%', y: '18%', delay: 0 },
    { size: 90, x: '85%', y: '25%', delay: 2 },
    { size: 100, x: '15%', y: '80%', delay: 4 },
    { size: 140, x: '80%', y: '70%', delay: 1 },
    { size: 80, x: '50%', y: '60%', delay: 3 },
    { size: 110, x: '20%', y: '40%', delay: 5 },
  ];

  return (
    <div className="fixed inset-0 pointer-events-none z-0">
      {leaves.map((leaf, index) => (
        <motion.div
          key={index}
          style={{
            position: 'absolute',
            left: leaf.x,
            top: leaf.y,
          }}
          animate={{
            y: [0, -10, 0],
            x: [0, 10, 0],
            scale: [1, 1.04, 1],
            rotate: [0, 8, 0],
          }}
          transition={{
            duration: 10,
            delay: leaf.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        >
          <PeepalLeaf size={leaf.size} />
        </motion.div>
      ))}
    </div>
  );
};

export default FloatingShapes;
